import { forwardRef, useMemo } from "react";
import { Table } from "../shared";

export const JobItemsTable = forwardRef(function JobItemsTable(
  {
    tableData,
    columns,
    job,
    meta,
    globalSearchFilters,
    hideCheckbox = true,
    rowClickExpand = true,
    getRowCanExpand = () => true,
    ...props
  },
  ref,
) {
  const tableMeta = useMemo(
    () => ({
      job,
      ...(meta || {}),
    }),
    [job, meta],
  );

  return (
    <Table
      ref={ref}
      {...props}
      data={tableData}
      columns={columns}
      meta={tableMeta}
      globalSearchFilters={globalSearchFilters}
      hideCheckbox={hideCheckbox}
      rowClickExpand={rowClickExpand}
      getRowCanExpand={getRowCanExpand}
    />
  );
});
